import { useMutation } from '@tanstack/react-query';
import { auth } from 'lib/api/firebase/firebase-api';
import { AppThunk } from 'lib/store/store';
import { resolveError } from 'lib/utils/formatters/error/resolve-error';
import { authSlice, AuthSliceActions } from './authSlice';
import { useSignInWithCustomTokenMutation } from 'lib/hooks/auth/use-auth';
import { useAnalytics } from 'lib/hooks/use-analytics';

export function useAuth(dispatch: Parameters<AppThunk>[0]) {
  const analytics = useAnalytics();
  const signIn = useMutation({
    mutationFn: (args: { email: string; password: string }) =>
      auth.signInWithEmailAndPassword(args.email, args.password),
    onMutate() {
      dispatch(AuthSliceActions.resetError());
    },
    onSuccess(userCredential) {
      analytics.track('auth:sign-in:success');
      const user = userCredential.user;
      if (!user) {
        dispatch(
          AuthSliceActions.setError('Internal server error. Please contact us')
        );
        return;
      }
    },
    onError(_error) {
      analytics.track('auth:sign-in:failure');
      const error = resolveError(_error);
      console.log('signInProcess error: ', error);
      dispatch(
        AuthSliceActions.setError(
          `Unable to sign in. Possible reasons are an invalid email or password. Error message: ${error.message}`
        )
      );
    }
  });
  const signOut = useMutation({
    mutationFn: () => auth.signOut(),
    onSuccess() {
      dispatch(authSlice.actions.signOut());
    }
  });

  const signInWithCustomToken = useSignInWithCustomTokenMutation();

  return { signIn, signOut, signInWithCustomToken };
}
